import {Component, OnInit} from '@angular/core';
import {StepComponent} from '../../step/step.component';
import {EingabeForm} from './eingabe.form';
import {Step, StepService} from '../../services/step.service';
import {Router} from '@angular/router';
import {StromcheckRequestService} from '../services/request.service';
import {StromcheckAnfrage} from '../anfrage/stromcheck.anfrage';
import {ElementService} from '../../services/element.service';
import {PortalService} from '../../services/portal.service';

/**
 * Overwrite the Generic step component for the first section fo the stromcheck.
 *
 * @inheritDoc
 */
@Component({
    selector: 'app-step-eingabe',
    templateUrl: '../../step/step.component.html',
    standalone: false
})
export class EingabeStepComponent extends StepComponent implements OnInit {

  /**
   * (input) data of the user
   */
  anfrage: StromcheckAnfrage;

  /**
   * @inheritDoc
   */
  formConfig: EingabeForm;

  /**
   * Overwrite the label prefix.
   */
  textkeyPrefix = 'stromcheck';

  hideHelpForSteps = [];

  /**
   * Holds the previous step object to move back.
   */
  previousStep: Step;

  /**
   * @inheritDoc
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: StromcheckRequestService,
              protected elementService: ElementService, protected portalService: PortalService) {
    super(stepService, router, elementService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    // add the correct form config that we need in this steps and init the parent form
    this.formConfig = new EingabeForm();
    super.ngOnInit();

    // get the current input data and preset it
    this.anfrage = this.requestService.getAnfrage();
    this.formConfig.anfrage = this.anfrage;

    this.formConfig.setStepComponent(this);
    this.formConfig.setData(this.anfrage.userInput);

    if (this.steps.currentStep && this.hideHelpForSteps.includes(this.steps.currentStep.name)) {
      this.hideHelp();
    }

    // update the previous step
    this.onStepUpdate();
  }

  /**
   * @inheritDoc
   */
  saveData(data: { [key: string]: any }) {
    // merge the data with the existing data
    this.anfrage.userInput = {...this.anfrage.userInput, ...data};
    this.requestService.setAnfrage(this.anfrage);

    // save the data also to the server
    this.requestService.saveDataToServer();

    super.saveData(data);
  }

  /**
   * Return the next step from a step list
   */
  getNextStepFromList(stepList: Step[]): any {
    // set all data again in the form to avoid using old data for toggle fields
    if (this.anfrage?.userInput && this.formConfig) {
      this.formConfig.updateFields(this.anfrage.userInput);
      // save the data again. In some case some fields are auto updated
      this.saveData({});
    }

    return super.getNextStepFromList(stepList);
  }

  /**
   * @inheritDoc
   */
  onSubmit() {
    super.onSubmit();

    if (this.form.valid === false) {
      // form is not valid, maybe form errors are shown. Scroll upwards
      this.elementService.scrollToElement(this.stepForm.nativeElement);
    }
  }

  /**
   * @inheritDoc
   */
  onStepUpdate() {
    super.onStepUpdate();

    // set previous step to intro page
    if (this.steps?.currentStep && this.steps?.currentStep?.name === 'basisinformationen/1') {
      this.previousStep = new Step('start', '../../../start');
    }

    // change helptext for special cases
    if(this.steps?.currentStep?.name === 'basisinformationen/6' && this.anfrage?.userInput?.gebaeudetyp === 'mehrfamilienhaus') {
      this.helpTextkey += '.wohnung';
    }
  }

}
